module.exports = __webpack_public_path__ + "watch_dogs.jpg";